import React, { FC } from 'react'
import { IconButton, Stack } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { useToast } from '../../contexts/ToastContext'

type Props = {
  value: string
}

export const Clipboard: FC<Props> = ({ value }) => {
  const { showToast } = useToast()

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(value)
    showToast('コピーしました', 'success', 2000, {
      vertical: 'bottom',
      horizontal: 'right',
    })
  }

  return (
    <Stack>
      <IconButton size="small" onClick={() => copyToClipboard()}>
        <ContentCopyIcon fontSize="small" />
      </IconButton>
    </Stack>
  )
}
